module.exports = __webpack_public_path__ + "img/mash-michael-ashley.da4f0209.png";